import { useMutation as e } from "@tanstack/react-query";
import a from "./video-call.api.js";
const u = (n) => e({
  mutationFn: async (t) => (await a.join(t)).data,
  ...n
}), c = (n) => e({
  mutationFn: async (t) => (await a.confirm(t)).data,
  ...n
}), p = (n) => e({
  mutationFn: async (t) => (await a.end(t)).data,
  ...n
}), m = (n) => e({
  mutationFn: async ({ videoCallId: t, dataUrl: o }) => (await a.takePhoto(t, o)).data,
  ...n
});
export {
  c as useConfirmHearingMutation,
  p as useEndVideoCallMutation,
  u as useJoinVideoCallMutation,
  m as useTakePhotoMutation
};
